import script from "./Switcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./Switcher.vue?vue&type=script&setup=true&lang=ts"

import "./Switcher.vue?vue&type=style&index=0&id=46214984&lang=scss&scoped=true"

import exportComponent from "/home/forge/usta.ge/vue-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46214984"]])

export default __exports__